export const REPORTS_HELP_ARTICLE_URL =
	'https://support.scoro.com/hc/en-us/articles/18326155777037';
